import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { ErrorMessageComponent } from '@app/shared/components/error-message/error-message.component';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';

@Component({
  selector: 'gc-floating-popup-base-error-message',
  standalone: true,
  imports: [ErrorMessageComponent, TranslateDirective],
  templateUrl: './floating-popup-base-error-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingPopupBaseErrorMessageComponent {
  public requestError = input<IApiBaseErrorResponse | null>(null);
  public customText = input<string | null>(null);
  public isMinimized = input<boolean>(false);
}
